import { useEffect, useState, useRef } from 'react';

export default function WhoItsFor() {
  const [animated, setAnimated] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimated(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const audiences = [
    {
      title: 'Solo Practitioners',
      description: "You don't have associates to draft motions. You don't have paralegals to format discovery. You do everything. Now you have AI that does the typing while you do the thinking",
    },
    {
      title: 'Small Firms',
      description: "Competing against firms with 10x your headcount. HushLegal is the equalizer. Draft in minutes what takes them hours",
    },
    {
      title: 'BigLaw Refugees',
      description: "You left the grind but kept the standards. HushLegal lets you produce BigLaw-quality work on your own terms",
    },
    {
      title: 'Public Defenders',
      description: "200 cases. Impossible deadlines. HushLegal helps you give every client the attention they deserve",
    },
    {
      title: 'Volume Practices',
      description: "Personal injury. Family law. Immigration. When you're filing 20 motions a week, every minute matters",
    },
  ];

  return (
    <section ref={sectionRef} className="relative py-16 sm:py-20 lg:py-32 bg-gradient-to-b from-[#0a0a0c] to-[#09090b]">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        <h2
          className={`text-white text-[28px] sm:text-[36px] lg:text-[48px] font-black text-center mb-8 sm:mb-12 lg:mb-16 transition-all duration-700 ${
            animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
        >
          Who It's For
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
          {audiences.map((audience, index) => (
            <div
              key={index}
              className={`p-6 sm:p-8 bg-[#0f0f11] border border-[#1a1a1c] rounded-2xl transition-all duration-700 hover:border-[#06b6d4] ${
                animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <h3 className="text-white text-lg sm:text-xl lg:text-2xl font-black mb-3 sm:mb-4">{audience.title}</h3>
              <p className="text-[#d4d4d8] text-sm sm:text-base leading-relaxed">{audience.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
